import { useState, useEffect } from "react";

const useIntersection = (
  ref: React.MutableRefObject<HTMLElement>,
  threshold: number = 0.0
) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold }
    );
    ref?.current && observer.observe(ref.current);
    return () => ref?.current && observer.unobserve(ref.current);
  }, [ref?.current]);

  return isVisible;
};

export const useIntersectionWithTimer = (
  ref: React.MutableRefObject<HTMLElement>,
  visibleTimeInMilliSec: number = 0,
  threshold: number = 0.0,
  showOnce: boolean = false
) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const isOnScreen = useIntersection(ref, threshold);

  useEffect(() => {
    let timerId: NodeJS.Timeout;
    if (isOnScreen) {
      const timeInMillis = visibleTimeInMilliSec;
      timerId = setTimeout(() => setIsVisible(true), timeInMillis);
    } else if (!showOnce) {
      setIsVisible(false);
    }
    return () => timerId && clearTimeout(timerId);
  }, [isOnScreen]);

  return isVisible;
};

export default useIntersection;
